import { useMediaQuery } from 'react-responsive';
import PaintIcon from '../../public/svg/paint.svg';
import ProcessIcon from '../../public/svg/process.svg';
import BuisnessIcon from '../../public/svg/buisnes.svg';
import MobileIcon from '../../public/svg/mobile.svg';

import styles from './real-estate-renty.module.css';
import {
  ComponentsDelivered,
  Container,
  Htag,
  HtagVariant,
  Paragraph,
} from '../../components';

export default function RealEstateRenty() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <section className={styles.renty}>
      <Container>
        <div className={styles.renty_wrapper}>
          <div className={styles.renty_top}>
            <Htag
              tag="h2"
              variant={HtagVariant.h2}
              className={styles.renty_title}
            >
              RENTY APP
            </Htag>
            <Paragraph className={styles.renty_text}>
              This is the home searching app where you may find a place to live
              by entering the criteria such as location, price, quantity of
              rooms, parking and other. In the search results you may view the
              details about the property you like and contact seller directly
              via the app.
            </Paragraph>
            <ComponentsDelivered
              className={styles.delivered}
              appearance="four"
              title="Components delivered:"
              data={[
                {
                  id: 1,
                  Icon: BuisnessIcon,
                  text: 'Business analysis and prototype',
                },
                {
                  id: 2,
                  Icon: PaintIcon,
                  text: 'Branding and app design',
                },
                {
                  id: 3,
                  Icon: MobileIcon,
                  text: 'iOS mobile app',
                },
                {
                  id: 4,
                  Icon: ProcessIcon,
                  text: 'Web admin panel',
                },
              ]}
            />
          </div>
          <div className={styles.renty_bottom}>
            <video
              className={styles.renty_video}
              src={isMobile ? '/video/Comp3.mp4' : '/video/Comp2.mp4'}
              autoPlay
              muted
              loop
              playsInline
            />
          </div>
        </div>
      </Container>
    </section>
  );
}
